import {passwordValidator, passwordValidatorMessage} from './../../../../../shared/utils/validators';
import React from 'react';
import {FormErrors, reduxForm, SubmissionError} from 'redux-form';
import {Forms} from '../../../../../shared/models/forms';
import {IOwnProps, IStateProps} from './model';
import View from './view';
import {FormValidationError, validationPipe} from '../../../../../shared/pipes/validation';

import {useAppDispatch} from '../../../../../redux';
import {updateProfilePassword} from '../../../../../redux/actions/profile';
import {IChangePasswordForm} from '../model';

const Form = reduxForm<IChangePasswordForm, IStateProps>({
  form: Forms.changePassword,
  destroyOnUnmount: false,
})(View);

const getFormErrors = (formData: IChangePasswordForm) =>
  validationPipe(formData, [
    {
      names: 'oldPassword',
      error: 'Обязательное поле',
      type: 'required',
    },
    {
      names: 'newPassword',
      error: 'Обязательное поле',
      type: 'required',
    },
    {
      names: 'newPassword',
      error: passwordValidatorMessage,
      type: 'custom',
      validator: passwordValidator,
    },
    {
      names: 'newPassword,confirmPassword',
      error: 'Пароли не совпадают',
      type: 'equals',
    },
  ]);

export const ChangePasswordForm: React.FC<IOwnProps> = ({onFormSubmitted}) => {
  const dispatch = useAppDispatch();

  const ownProps: IStateProps = {
    onSubmit: async (formData: IChangePasswordForm) => {
      const submissionError = getFormErrors(formData);
      if (submissionError) {
        throw new SubmissionError(submissionError);
      }

      try {
        await dispatch(updateProfilePassword(formData.oldPassword, formData.newPassword));
      } catch (e: any) {
        let errorText = e.data?.[0]?.message || e.message || 'Ошибка. Повторите еще раз';
        throw new SubmissionError({
          oldPassword: new FormValidationError(errorText, true),
        } as FormErrors<any, FormValidationError>);
      }

      if (onFormSubmitted) {
        onFormSubmitted();
      }
    },
  };

  return React.createElement(Form, ownProps);
};
